import styled from 'styled-components';

export const StandardDropzonePlaceholder = styled.div`
  width: 100%;
  border: 1px dashed ${(props) => props.theme.palette.grayLighter};
  border-radius: ${(props) => props.theme.borderRadius};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.theme.fontSizeSm};
  line-height: 2;
  text-align: center;

  &:focus {
    outline: 0;
  }
`;

export const StretchedDropzonePlaceholder = styled(StandardDropzonePlaceholder)`
  height: 15rem;
  padding: 3.5rem 0;
  justify-content: space-between;
  position: relative;
`;
